<!-- <div class="container">
    <div class="row g-3 justify-content-center">
        <div class="col-lg-4 col-xl-4 col-12">
            <h3>หักคะแนนสมาชิก</h3>
            <br>
            <p>ค้นหาสมาชิกด้วยเบอร์โทร</p>
            <div class="input-icon-end">
                <input type="number" class="form-control" [(ngModel)]="tel" (change)="searchMember(sm)" #sm>
                <span class="material-symbols-outlined m-action">
                    search
                </span>
            </div>
        </div>
    </div>
    <div class="row g-3 mt-3 justify-content-center" *ngIf="memberItems?.Member_id">
        <div class="col-lg-4 col-xl-4 col-12" *ngIf="memberItems?.Member_id != ''">
            <div class="rank">
                <img [src]="memberItems.Rank_image" alt="">
            </div>
            <p class="mt-3 fs-5"> <b> ชื่อ-สกุล</b> : {{memberItems.Member_name}}</p>
            <p>จำนวนเงิน</p>
            <input type="number" class="form-control" (input)="Amount(am)" #am>
            <br>
            <p>หัก : {{point}} คะแนน</p>
            <textarea class="form-control remark" [(ngModel)]="remark"></textarea>
            <br>
            <button class="btn btn-primary" (click)="DeductPoint()">ยืนยัน</button>
        </div>
        <div class="col-lg-4 col-xl-4 col-12" *ngIf="memberItems?.Member_id == ''">
            <h1>ไม่พบสมาชิก</h1>
        </div>
    </div>
</div> -->




<div class="container">
    <div class="row g-3">
        <div class="col-12">
            <h3>หักคะแนน</h3>
        </div>
    </div>
    <div class="card p-3">
        <div class="row g-3">
            <div class="col-xl-6 col-lg-8 col-md-10 col-12">
                <p class="mb-1">ระบุหมายเลขโทรศัพท์</p>
                <div class="input-icon-start">
                    <input type="number" class="form-control" placeholder="ค้นหาเบอร์โทรศัพท์" [(ngModel)]="tel"
                        (change)="searchMember()">
                    <span class="material-symbols-outlined m-action">
                        search
                    </span>
                </div>
                <br>
                <ng-container *ngIf="memberItems?.Member_id">
                    <div class="card-text">
                        <div class="rank">
                            <img [src]="memberItems.Rank_image" alt="">
                        </div>
                        <div class="name ms-2">
                            <label>ชื่อ-นามสกุล</label>
                            <br>
                            <span>{{memberItems.Member_name}}</span>
                        </div>
                    </div>
                    <br>
                    <p class="mb-1">ระบุจำนวนเงิน</p>
                    <div class="input-text-end">
                        <input type="text" class="form-control" placeholder="0.00" (input)="Amount(am)" #am>
                        <span>บาท</span>
                    </div>
                    <br>
                    <p class="mb-1">หักคะแนน</p>
                    <div class="input-text-end">
                        <input type="text" class="form-control" disabled [value]="point || 0">
                        <span>คะแนน</span>
                    </div>
                    <br>
                    <textarea class="form-control remark" [(ngModel)]="remark" placeholder="หมายเหตุ"></textarea>
                    <br>
                    <button class="btn btn-primary" (click)="DeductPoint()">ยืนยัน</button>
                </ng-container>
                <div class="col-12" *ngIf="memberItems?.Member_id == ''">
                    <h3>ไม่พบสมาชิก</h3>
                </div>
            </div>
        </div>
    </div>
</div>